function toggleStickyHeader() {
  const header = document.querySelector('.header__wrapper');

  if (window.scrollY > 20) {
    document.body.classList.add('header-sticky-custom');
    header.classList.add('js__header__stuck');
    console.log('>20');
  } else {
    document.body.classList.remove('header-sticky-custom');
    header.classList.remove('js__header__stuck');
    console.log('menos 20');
  }
}
window.addEventListener('load', toggleStickyHeader);
window.addEventListener('scroll', toggleStickyHeader);

const cartLink = document.querySelector('.navlink--cart');

cartLink.addEventListener('click', (e) => {
  e.preventDefault();
});